module.exports = __webpack_public_path__ + "static/img/MineTopBg.26ff389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/MineTopBg.png
// module id = vM1g
// module chunks = 39